import type { CustomEventsContext } from '../types'

type DownloadFile = { content: Blob; filename: string }

export default function (this: CustomEventsContext, file: DownloadFile): Promise<void> {
  const sendEvent = this.sendEvent
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader()

      reader.readAsDataURL(file.content)

      reader.onload = function () {
        const result = reader.result
        const content = typeof result === 'string' ? result.replace(/^data:(application|image)\/.+;base64,/, '') : ''
        sendEvent('download', {
          ...file,
          filename: file.filename.replace(/\//g, '_'),
          content,
        })
        resolve()
      }
    } catch (e) {
      reject(e)
    }
  })
}
